import { Link } from 'react-router';
import { Button, Card, DescriptionList, Icon, PageHeader, Segmented, useAuth, useTheme, type ThemePref } from '@saas/ui';
import { useNavigationLayout, type NavigationLayout } from '../shell/navigation-layout.js';

/** ⚙ 設定ホーム（SET-01 の Web 版） */
export function SettingsHomePage() {
  const { me, logout, isAdmin, can } = useAuth();
  const { pref, setPref } = useTheme();
  const { layout, setLayout } = useNavigationLayout();
  return (
    <>
      <PageHeader title="設定" />
      <div className="flex flex-col gap-4">
        <Card padding="none">
          <ul>
            <li>
              <Link to="/settings/profile" className="flex min-h-14 items-center gap-3 px-5 text-body hover:bg-sunken">
                <Icon name="person" size={24} />
                <span className="flex-1">プロフィール・パスワード</span>
                <Icon name="chevron_right" size={24} className="text-fg-tertiary" />
              </Link>
            </li>
            <li className="border-t border-line">
              <Link to="/settings/notifications" className="flex min-h-14 items-center gap-3 px-5 text-body hover:bg-sunken">
                <Icon name="notifications" size={24} />
                <span className="flex-1">通知設定（この端末のプッシュ通知）</span>
                <Icon name="chevron_right" size={24} className="text-fg-tertiary" />
              </Link>
            </li>
            {/* SFA 1B: 自分の Gmail / Microsoft 365 の接続（SFA機能拡張設計書 §4・§6.1・§15.2.6） */}
            {can('core.mail.connect') ? (
              <li className="border-t border-line">
                <Link to="/settings/mail-connections" className="flex min-h-14 items-center gap-3 px-5 text-body hover:bg-sunken">
                  <Icon name="mail" size={24} />
                  <span className="flex-1">メール接続（Gmail / Microsoft 365）</span>
                  <Icon name="chevron_right" size={24} className="text-fg-tertiary" />
                </Link>
              </li>
            ) : null}
            {isAdmin ? (
              <li className="border-t border-line">
                <Link to="/admin" className="flex min-h-14 items-center gap-3 px-5 text-body hover:bg-sunken">
                  <Icon name="shield" size={24} />
                  <span className="flex-1">管理コンソール</span>
                  <Icon name="chevron_right" size={24} className="text-fg-tertiary" />
                </Link>
              </li>
            ) : null}
          </ul>
        </Card>
        <Card>
          <h2 className="mb-3 text-headline">表示</h2>
          <h3 className="mb-2 text-body font-medium">メニューの配置</h3>
          <p className="mb-3 text-callout text-fg-secondary">PC 画面のメニューを選べます。変更はすぐに反映され、このブラウザに保存されます。画面が狭い場合はメニューボタンから開きます。</p>
          <Segmented<NavigationLayout>
            aria-label="メニューの配置"
            value={layout}
            onChange={setLayout}
            options={[
              { value: 'top', label: '上部ナビゲーション' },
              { value: 'sidebar', label: '左側メニュー' },
            ]}
          />
          <h3 className="mb-2 mt-6 text-body font-medium">テーマ</h3>
          <p className="mb-2 text-callout text-fg-secondary">Paper &amp; Ink — 温かいライトと落ち着いたダーク。「端末設定」は端末の明るさ設定に従います。</p>
          <Segmented<ThemePref>
            aria-label="テーマ"
            value={pref}
            onChange={setPref}
            options={[
              { value: 'system', label: '端末設定' },
              { value: 'light', label: 'ライト' },
              { value: 'dark', label: 'ダーク' },
            ]}
          />
        </Card>
        <Card>
          <h2 className="mb-3 text-headline">会社</h2>
          <DescriptionList
            items={[
              { label: '会社名', value: me?.tenant.name },
              { label: 'サブドメイン', value: me?.tenant.slug },
              { label: 'プラン', value: me?.tenant.plan },
              { label: 'ロール', value: me?.roles.join(' / ') },
            ]}
          />
        </Card>
        <Card>
          <h2 className="mb-3 text-headline">ログアウト</h2>
          <p className="mb-3 text-callout text-fg-secondary">この端末のログイン状態を終了します。</p>
          <Button variant="secondary" icon="logout" onClick={() => void logout()}>
            ログアウト
          </Button>
        </Card>
      </div>
    </>
  );
}
